import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { get } from 'lodash';
import ClusterMarkerPopup from './ClusterMarkerPopup';
import PieChartWrapper from './PieChartWrapper';

const minSize = 35;
const maxSize = 80;
const clusterBorderSize = 3;

function ClusterMarker({
  text,
  onTouchStart,
  onShowMarkers,
  data,
  $geoService,
  $getDimensions,
  $dimensionKey,
  isMobile,
  toggleZoom,
  numPoints,
  maxPoints,
}) {
  const [points, setPoints] = useState({
    available: 0,
    alert: 0,
    partially_oos: 0,
    monitored: 0,
    totally_oos: 0,
    unknown: 0,
  });

  // max = 100%(=maxSize), current = x, then  x = (current * maxSize) / max (currect cluster size) - proportion
  const sizeRange = maxSize - minSize;
  const currentSize = minSize + (+numPoints * sizeRange) / +maxPoints;
  const clusterStyles = {
    width: `${currentSize}px`,
    height: `${currentSize}px`,
  };

  const clusterContainerStyles = {
    width: `${currentSize + clusterBorderSize * 2}px`, // 3 = cluster border size
    height: `${currentSize + clusterBorderSize * 2}px`,
    left: `${-currentSize / 2 + clusterBorderSize * 2}px`,
    top: `${-currentSize / 2 + clusterBorderSize * 2}px`,
  };

  useEffect(() => {
    const pointsState = {
      available: 0,
      alert: 0,
      partially_oos: 0,
      monitored: 0,
      totally_oos: 0,
      unknown: 0,
    };

    if (data && data.length) {
      for (const point of data) {
        const state = get(point, 'data.state', 'unknown');

        pointsState[state] += 1;
      }
    }

    setPoints(pointsState);
  }, [data]);

  return (
    <motion.div
      transition={{
        type: 'spring',
        stiffness: 100,
        damping: 7,
        precision: 0.001,
      }}
      whileHover={{ scale: 1.08, zIndex: 99999 }}
      style={{ zIndex: 999, position: 'relative' }}
    >
      <ClusterMarkerPopup
        onTouchStart={onTouchStart}
        pointsData={points}
        containerStyles={clusterContainerStyles}
        $geoService={$geoService}
        $getDimensions={$getDimensions}
        $dimensionKey={$dimensionKey}
        isMobile={isMobile}
        toggleZoom={toggleZoom}
      >
        <PieChartWrapper
          onPieChartClick={() => onShowMarkers(data)}
          clusterStyles={clusterStyles}
          text={text}
          pointsData={points}
        />
      </ClusterMarkerPopup>
    </motion.div>
  );
}

export default ClusterMarker;
